import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import { PodcastPageContext } from "@pages/Section/layouts/PodcastsPage/utils/types";
import { useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import PodcastPageContent from "./PodcastsPageContent";

export default function PodcastsPage(): React.ReactElement {
  const { context } = useRouteContext<PodcastPageContext>();

  if (context && context.statusCode !== HttpStatusCode.Ok) {
    // StatusCode is not 200
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }) => {
        if (kind === "section") {
          return <PodcastPageContent {...data} />;
        }

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
